import { BaseModelData } from '../base-model-data'

export interface ProcedureData extends BaseModelData {
  code: string
  name: string
  type: string
  serviceCodes?: string[]
  category?: string
  topModifiers?: any
  supportedModifiers?: any
}

/** Where a CPT dialog suggestion came from: a clinic procedure, the CMS code list, nowhere, or the NLP model. */
export enum ProcedureSuggestionSource {
  CLINIC = 'clinic',
  CMS = 'cms',
  UNKNOWN = 'unknown',
  MODEL = 'model',
}

/** One CPT dialog option, as `POST /cms/suggest` returns it when the request sends `clinicProcedures: true`. */
export interface ProcedureSuggestion {
  source: ProcedureSuggestionSource
  code: string
  codes: string[]
  name?: string
  productId?: string
}

/** The CPT dialog's answer for one query. */
export interface ProcedureSuggestionResults {
  suggestions: ProcedureSuggestion[]
  /** How many matched. Above `suggestions.length` when the route sent only the best of them. */
  total: number
}
